const HYP_TITLE = 'LambdaTest-HyperExecute';

const setTitle = (pageName = '') => {
  document.title = pageName ? `${HYP_TITLE}-${pageName}` : HYP_TITLE;
};

export default setTitle;
